import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// Component to check auth state and redirect accordingly
const AuthWrapper = ({ children }) => {
  const location = useLocation();
  const userData = JSON.parse(localStorage.getItem("user")) || null;
  const auditorData = JSON.parse(localStorage.getItem("auditor")) || null;
  const dUserData = JSON.parse(localStorage.getItem("duser")) || null;
  
  // Public routes that don't require authentication check
  const publicRoutes = [
    '/','/HomePage', '/overview', '/features', '/pricing', '/contact', '/'
  ];
  
  // Auth routes that should redirect to dashboard if already authenticated
  const authRoutes = [
    '/LoginTabs', '/RegisterTabs', '/LoginPage', '/auditor-login',
    '/forgot-password/admin', '/forgot-password/auditor',
    '/IndividualRegister', '/BusinessRegister','/FactoryRegister'
  ];
  
  // Check if current path is public
  const isPublicRoute = publicRoutes.includes(location.pathname);
  
  // Check if current path is an auth route (login/register)
  const isAuthRoute = authRoutes.some(route => 
    location.pathname === route || location.pathname.startsWith(`${route}/`)
  );
  
  // If user is on auth route but already logged in, redirect to appropriate dashboard
  if (isAuthRoute) {
    if (userData && userData.accountType === 'individual' && userData.role === 'Branch admin') {
      return <Navigate to="/IndividualDashboard" />;
    }
    else if (userData && userData.accountType === 'business' && userData.role === 'Company admin') {
      return <Navigate to="/BusinessDashboard" />;
    }
    else if (userData && userData.accountType === 'factory' && userData.role === 'Factory admin') {
      return <Navigate to="/FactoryDashboard" />;
    }
    else if (userData && userData.accountType === 'Joined Branch' && userData.role === 'Factory admin') {
      return <Navigate to="/JBranchDashboard" />;
    }
    else if (auditorData && auditorData.accountType === 'individual' && auditorData.role === 'Branch auditor') {
      return <Navigate to="/InAuditorDashboard" />;
    }
    else if (auditorData && auditorData.accountType === 'business' && auditorData.role === 'Company auditor') {
      return <Navigate to="/BusinessAuditorDashboard" />;
    }
    else if (auditorData && auditorData.accountType === 'factory' && auditorData.role === 'Factory auditor') {
      return <Navigate to="/FactoryAuditorDashboard" />;
    }
    else if (auditorData && auditorData.accountType === 'Joined Branch' && auditorData.role === 'Factory auditor') {
      return <Navigate to="/JBranchAuditorDashboard" />;
    }
    else if (dUserData && dUserData.accountType === 'individual' && dUserData.role === 'Department user') {
      return <Navigate to="/InDuserDashboard" />;
    }
    else if (dUserData && dUserData.accountType === 'business' && dUserData.role === 'Department user') {
      return <Navigate to="/BusinessDuserDashboard" />;
    }
    else if (dUserData && dUserData.accountType === 'factory' && dUserData.role === 'Department user') {
      return <Navigate to="FactoryDuserDashboard" />;
    }
    else if (dUserData && dUserData.accountType === 'Joined Branch' && dUserData.role === 'Department user') {
      return <Navigate to="JBranchDuserDashboard" />;
    }
  }
  
  // Allow access to children (the rest of the app)
  return <>{children}</>;
};

export default AuthWrapper;